import {
  HISCON_SET_HISTORICO_SUCCESS,
  HISCON_SET_HISTORICO_PORTAL_ESTADUAL_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
  historico: [],
  historicoPortalEstadual: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case HISCON_SET_HISTORICO_SUCCESS:
      return { ...state, historico: payload };
    case HISCON_SET_HISTORICO_PORTAL_ESTADUAL_SUCCESS:
      return { ...state, historicoPortalEstadual: payload };
    default:
      return state;
  }
};
